'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _songs = require('redux/modules/songs');

var songsActions = _interopRequireWildcard(_songs);

var _SearchBar = require('components/SearchBar/SearchBar');

var _SearchBar2 = _interopRequireDefault(_SearchBar);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./SongsListSearchBar.scss');

var SongsListSearchBar = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    kw: state.songs.kw
  };
}, (0, _extends3.default)({}, songsActions)), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SongsListSearchBar, _Component);

  function SongsListSearchBar() {
    (0, _classCallCheck3.default)(this, SongsListSearchBar);
    return (0, _possibleConstructorReturn3.default)(this, (SongsListSearchBar.__proto__ || (0, _getPrototypeOf2.default)(SongsListSearchBar)).apply(this, arguments));
  }

  (0, _createClass3.default)(SongsListSearchBar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          setSongsFilter = _props.setSongsFilter,
          className = _props.className,
          kw = _props.kw,
          onChange = _props.onChange,
          autoFocus = _props.autoFocus;


      return _react2.default.createElement(_SearchBar2.default, {
        autoFocus: autoFocus,
        className: (0, _bind2.default)(className, styles.bar),
        onChange: onChange,
        kw: kw,
        onSetFilter: setSongsFilter
      });
    }
  }]);
  return SongsListSearchBar;
}(_react.Component), _class2.propTypes = {
  autoFocus: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  kw: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  setSongsFilter: _propTypes2.default.func
}, _class2.defaultProps = {
  onChange: _noop3.default
}, _temp)) || _class);
exports.default = SongsListSearchBar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SongsList/SongsListSearchBar.js
// module id = 2100
// module chunks = 1